<div class="form-group">
  <!-- TODO: translationKey='' -->
  <label
    [translatable]="{
      transKey: labelTranslationKey,
      modEnum: labelTranslationModuleEnum
    }"
    class="form-label"
    *ngIf="!!title"
  >
    {{ title }}
    <span *ngIf="isRequired" class="astrix-red">*</span>
  </label>

  <div
    [translatable]="{
      transKey: placeholderTranslationKey,
      modEnum: placeholderTranslationModuleEnum
    }"
    *ngIf="!isRange"
  >
    <nz-date-picker
      [(ngModel)]="value"
      [nzFormat]="
        showDayOnInput
          ? 'dd-MM-yyyy EEEE'
          : ShowTime
          ? 'dd-MM-yyyy, hh:mm a'
          : defaultDateFormat
      "
      [nzDisabledDate]="disabledDate"
      [nzDisabledTime]="ShowTime && disabledHours"
      [nzShowTime]="ShowTime && { nzUse12Hours: true, nzFormat: 'hh:mm a' }"
      [nzPlaceHolder]="placeholder"
      [nzDisabled]="disabled"
      [nzShowToday]="ShowToday"
      (nzOnOpenChange)="change()"
      (ngModelChange)="inputChange()"
    ></nz-date-picker>
  </div>

  <div *ngIf="isRange" class="d-flex">
    <span
      [translatable]="{
        transKey: placeholderTranslationKey[0],
        modEnum: placeholderTranslationModuleEnum
      }"
    ></span>
    <nz-range-picker
      [(ngModel)]="value"
      [nzFormat]="
        showDayOnInput
          ? 'dd-MM-yyyy EEEE'
          : ShowTime
          ? 'dd-MM-yyyy, hh:mm a'
          : defaultDateFormat
      "
      [nzDisabledDate]="disabledDate"
      [nzShowTime]="ShowTime && { nzUse12Hours: true, nzFormat: 'hh:mm a' }"
      [nzPlaceHolder]="[
        translateService.instant(placeholder[0]),
        translateService.instant(placeholder[1])
      ]"
      [nzDisabled]="disabled"
      [nzShowToday]="ShowToday"
      (nzOnOpenChange)="change()"
      (ngModelChange)="inputChange()"
    ></nz-range-picker>
    <span
      [translatable]="{
        transKey: placeholderTranslationKey[1],
        modEnum: placeholderTranslationModuleEnum
      }"
    ></span>
  </div>

  <app-validation
    [title]="title"
    [length]="length"
    *ngIf="isSubmitted && control?.invalid"
    [control]="control"
  ></app-validation>
</div>
